'use strict'

# UserAgent
_ua = do ->
  IE = document.uniqueID
  ltIE6 = typeof window.addEventListener is undefined and typeof document.documentElement.style.maxHeight is undefined
  ltIE7 = typeof window.addEventListener is undefined and typeof document.querySelectorAll is undefined
  ltIE8 = typeof window.addEventListener is undefined and typeof document.getElementsByClassName is undefined
  ltIE9 = IE and typeof window.Worker is undefined
  IE6 = IE and ltIE6
  IE7 = IE and ltIE7 and not ltIE6
  IE8 = IE and ltIE8 and not ltIE7 and not ltIE6
  IE9 = IE and ltIE9 and not ltIE8 and not ltIE7 and not ltIE6
  IE10 = IE and not ltIE9 and not ltIE8 and not ltIE7 and not ltIE6
  Webkit = not document.uniqueID and not window.opera and not window.sidebar and not window.orientation and window.localStorage
  Safari = Webkit and navigator.vendor.search(/apple/i) isnt -1
  Chrome = Webkit and navigator.vendor.search(/google/i) isnt -1

  return {
    IE:IE,
    ltIE6:ltIE6,
    ltIE7:ltIE7,
    ltIE8:ltIE8,
    ltIE9:ltIE9,
    IE6:IE6,
    IE7:IE7,
    IE8:IE8,
    IE9:IE9,
    IE10:IE10,
    Firefox:window.sidebar,
    Opera:window.opera,
    Webkit:Webkit,
    Safari:Safari,
    Chrome:Chrome,
    Mobile:window.orientation
  }

# URL
url = do ->
  href = location.href.split('/')

  localRegex = /^\d+\.\d+\.\d+\.\d+/
  workRegex = /^.*\/pc\/[^\/]+\/.*$/

  for val , i in href
    if val is '' or i is href.length - 1 and val.indexOf('.')
      href.splice(i,1)

  if localRegex.test(location.hostname) is true or location.hostname.indexOf('localhost') isnt -1
    length = 2

  else if workRegex.test(location.href) is true
    length = 3

    for val , i in href
      if val is 'pc' and href[i-1] is 'work'
        length = 4

  else
    length = 1

  path = ''

  for j in [0..(length)]
    path += href[j]

    if j is 0
      path += '//'

    else
      path += '/'

  return path

# スムーススクロール関数モーション定義
jQuery.extend(
  jQuery.easing,{
    easeInOutCirc:
      (x, t, b, c, d) ->
        if (t/=d/2) < 1
          return -c/2 * (Math.sqrt(1 - t*t) - 1) + b
        c/2 * (Math.sqrt(1 - (t-=2)*t) + 1) + b
  }
)

$(()->
  $id = $('body').attr('id')
  $class = $('body').attr('class')

  # フッター高さ取得
  footerHeight =
    ()->
      add = 0
      height = $('#footer').height()
      outerHeight = $('#footer').outerHeight(true)
      diff = height - outerHeight
      if diff > 0
        $('#content').css('padding-bottom',height+add)
        $('#footer').css('height',height)
      else
        $('#content').css('padding-bottom',outerHeight+add)
        $('#footer').css('height',height)
      return

  footerHeight()

  $(window).on('load resize',
    ->
      footerHeight()
  )

  smoothScroll = ($target)->
    $(
      if (navigator.userAgent.indexOf('Opera') isnt -1)
      then (
        if document.compatMode is 'BackCompat'
        then 'body'
        else 'html'
      )
      else 'html,body'
    ).animate({
      scrollTop:$($target.attr('href')).offset().top - $('.h-navi').height() + 1
    },{
      easing:'easeInOutCirc',
      duration:1000
    })

    return false

  $('a[href^="#"]'+'a[href!="#"]').on('click.smoothScroll'
    (e)->
      e.preventDefault()
      smoothScroll($(this))

      return
  )

  $svgs = $('#m-clinic-logo')
  $svgs.addClass('is-inactive')
  
  $(window).on('load',
    ()->
      # SVG 色変え
      $.each($svgs,
        (key, val)->
          $svg = $(val.contentDocument)
          $svg.find('path').css('fill', '#4f4737')
          $(val).removeClass('is-inactive')
          $(val).addClass('is-active')
      )
  )
  
  $(window).on('load resize',
    ->
      $('.l-header').css('height', $('.m-page-link-list').height() + 70)
      $('.m-page-link').css('height', $('.m-page-link-list').height())
      $('.m-photo__details').css('height', $('.m-photo__list').height())
  )
  
  $('.js-tab-item a[href^="#"]').on('focus',
    (e)->
      $(this).off('click.smoothScroll')
  )
  
  $('.js-tab-item a[href^="#"]').on('click',
    (e)->
      $parent = $(this).closest('.js-tab-box')
      e.preventDefault()
      $parent.find('.js-tab-item').removeClass('is-active')
      $(this).parent().addClass('is-active')
      $parent.find('.js-tab-box-contents').removeClass('is-active')
      $($(this).attr('href')).addClass('is-active')
  )
  
  $('.m-privacypolicy-title').on('click',
    (e)->
      if $('+.m-privacypolicy-contents', this).css('display') is 'none'
        $(this).addClass('is-open')
        $('+.m-privacypolicy-contents', this).slideDown('normal')
      else
        $(this).removeClass('is-open')
        $('+.m-privacypolicy-contents', this).slideUp('normal')
      return
  )
  
  
  # ヘッダー追従メニュー
  firstUpFlg = false
  firstDownFlg = true
  
  $('.h-navi').headroom({
    offset: $('.l-header').height() - $('.h-navi').outerHeight()
    onPin: ()->
    onUnpin: ()->
    onTop: ()->
    onNotTop: ->
  })
  
  $gnavi =$('.h-navi')
  $gnaviItem =$('.h-navi-item')
  $navContents = $('.js-nav-point')
  navContentsPos = {}
  
  $navContents.each(
    (index, val)->
      if $(this).attr('id')
        position = {}
        position[$(this).attr('id')] = $(this).offset().top
        navContentsPos[Object.keys(navContentsPos).length] = position
  )
  
  $(window).scroll(
    ()->
      $.each(navContentsPos,
        (key, val)->
          target = Object.keys(val)
          $target = $('#'+target)
  
          if $(window).scrollTop() >= $target.position().top - $gnavi.height() and
          $(window).scrollTop() < $target.position().top + $target.outerHeight(true)
            $gnavi.find('.'+target).addClass('is-active')
            $gnaviItem.not('.'+target).removeClass('is-active')
  
          if $(window).scrollTop() < $($navContents.get(0)).position().top - $gnavi.height()
            $gnaviItem.removeClass('is-active')
  
          if $(window).scrollTop() >= $('.l-header').height()
            $('.l-fix-cv').removeClass('is-hide')
          else
            $('.l-fix-cv').addClass('is-hide')
      )
  )
  
  $('.h-navi-item').find('a').on('mouseover',
    (e)->
      $(this).off('click.smoothScroll')
  )
  
  $('.h-navi-item').find('a').on('click',
    (e)->
      e.preventDefault()
  
      if not $(this).parent().hasClass('is-active')
        $(this).one('click.smoothScroll', smoothScroll($(this)))
  )
  
  if not $gnavi?
    $gnavi =$('.h-navi')
  else
  
  new WOW().init()
  
  # $('.cv-link-list').hover (->
  #   $('.m-cv-inner').addClass('is-hover')
  # ), ->
  #   $('.m-cv-inner').removeClass('is-hover')
  
  $(window).on('load', ()->
    if location.hash isnt ''
      $(
        if (navigator.userAgent.indexOf('Opera') isnt -1)
        then (
          if document.compatMode is 'BackCompat'
          then 'body'
          else 'html'
        )
        else 'html,body'
      ).animate({
        scrollTop:$(location.hash).offset().top - $('.h-navi').outerHeight()
      },{
        duration:1
      })
  )
  
)
